import React from "react";
import PropTypes from "prop-types";

import { SearchBox } from "./coveo/SearchBox";
import { CoveoEngineWrapper } from "./coveo/CoveoEngineWrapper";
import { Auth0DocsSearchBox } from "./Auth0DocsSearchBox";
import { getFeatureFlagWithDefault } from "../../common/featureFlags";

export const StandaloneSearchBox = () => {
  const showGenAiAnswers = getFeatureFlagWithDefault('support_center_coveo_gen_ai', false);

  return (
    <CoveoEngineWrapper fallback={<Auth0DocsSearchBox />}>
      <SearchBox redirectionUrl="/search" showAINotice={showGenAiAnswers} />
    </CoveoEngineWrapper>
  );
};

StandaloneSearchBox.propTypes = {
  redirectionUrl: PropTypes.string
};
